// NPM Imports
import React, { Fragment } from "react";

export default function RevvGridSingleSelect(props) {
  const { field, readOnly, row, options } = props;
  const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
  const editable =
    row.rowData[field] &&
    row.rowData[field].cellMeta &&
    row.rowData[field].cellMeta.editable;
  return (
    <Fragment>
      {readOnly || !editable ? (
        <div className="rs-cell">{cellValue}</div>
      ) : (
        <select
          value={cellValue}
          className={`rs-select-container rs-cell ${
            editable && !readOnly ? "is-editable" : ""
          }`}
          style={{
            WebkitAppearance: "none",
          }}
          onChange={e => props.onChange(e.target.value)}
          data-test="rgsingleselect-select">
          {options.map(data => (
            <option key={data}>{data}</option>
          ))}
        </select>
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/RevvGrid/Components/RG_SingleSelect.js